import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets window scroll to top whenever the route changes.
 * Without this, React Router keeps the previous scroll position when navigating —
 * which makes pages appear to "open at the bottom" if the user scrolled there on
 * the previous route.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Use instant behavior so the user doesn't see a scroll animation on nav.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
